
<div>
  <page-header>
    <div class="boardTitle mt-3 mr-3 ml-3 font-weight-bold align-self-center">
      {{ boardTitle }}
    </div>
    <router-link class="mt-3 mb-1" :to="{ name: 'Board', params: { id: $route.params.id } }">
      <div class="badgebutton active text-nowrap c-white">
        <i class="far fa-clock"></i>
        Back to Board
      </div>
    </router-link>
  </page-header>

  <div class="statistic-container">
    <LabelsStatistics />
  </div>

  <AppInfo />
</div>
